import { render, staticRenderFns } from "./RegionHierarchy.vue?vue&type=template&id=678f76b2&"
import script from "./RegionHierarchy.vue?vue&type=script&lang=js&"
export * from "./RegionHierarchy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678f76b2')) {
      api.createRecord('678f76b2', component.options)
    } else {
      api.reload('678f76b2', component.options)
    }
    module.hot.accept("./RegionHierarchy.vue?vue&type=template&id=678f76b2&", function () {
      api.rerender('678f76b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/RegionHierarchy.vue"
export default component.exports